var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"branch",class:[
        { 'branch--decorated': _vm.decoration }
    ]},_vm._l((_vm.productList),function(product){return _c('ProductCard',{key:product.id,staticClass:"branch__child",attrs:{"product-id":product.id,"disabled":!_vm.currentPurchase.modifyPurchase && _vm.cardDisabled}})}))}
var staticRenderFns = []

export { render, staticRenderFns }